module.exports = __webpack_public_path__ + "img/leftthigh-endomorph-female.9476fcc8.svg";